import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { AgeRange, AgeRangesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class AgeRangesDataService {

  private uri: string = `${environment.apiUrl}age-ranges`;
  private cacheKey: string = 'ageRanges.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getAgeRange(id: number): Observable<AgeRange|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getAgeRanges(parameters: {[param: string]: string | string[]}): Observable<AgeRangesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addAgeRange(data: AgeRange): Observable<AgeRange|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addAgeRanges(data: AgeRange[]): Observable<AgeRange[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateAgeRange(data: AgeRange): Observable<AgeRange|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateAgeRanges(data: AgeRange[]): Observable<AgeRange[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchAgeRange(data: AgeRange): Observable<AgeRange|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchAgeRanges(data: AgeRange[]): Observable<AgeRange[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteAgeRange(data: AgeRange): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteAgeRanges(data: AgeRange[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((ageRange) => {
      ids.push(ageRange.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
